import { Button, required, useNotify, useRefresh } from "react-admin";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Box, alpha } from "@mui/material";

import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

import FileInputWithlabel from "./FileInputWithLabel";

// Make the upload area read as a drop target instead of a flat grey band.
const dropZoneSx = {
  "& .RaFileInput-dropZone": {
    border: theme => `1px dashed ${alpha(theme.palette.primary.main, 0.5)}`,
    borderRadius: "5px",
    backgroundColor: "#FFF",
    cursor: "pointer",
    transition: "background-color .15s, border-color .15s",
    "&:hover": {
      borderColor: theme => theme.palette.primary.main,
      backgroundColor: theme => alpha(theme.palette.primary.main, 0.06),
    },
  },
};

/*
 * Single-file counterpart of NodeLeaves/AttachFilesDialog — the caller supplies the endpoint,
 * so the same dialog serves any "attach one document to this record" operation.
 */
const AttachFileDialog = ({
  url,
  title,
  label,
  buttonLabel = "Прикачи файл",
  placeholderText,
  fileField = "file",
  iconOnly = false,
}) => {
  const notify = useNotify();
  const refresh = useRefresh();

  if (!url) return null;

  const handleConfirm = async ({ document }) => {
    // required() lets an empty FileInput through once it has been touched and cleared.
    if (!(document?.rawFile instanceof File)) {
      notify("Прикачете файл.", { type: "warning" });
      return false;
    }

    // Pass the whole FileInput value — createFormData appends the File off its `rawFile`.
    await dataProvider.customRequest(url, { [fileField]: document }, "POST", null, true);

    notify("Файлът е прикачен успешно.", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent={title}
      dialogSize="sm"
      saveTitle="Прикачи"
      disableBackdropClose
      onConfirm={handleConfirm}
      triggerButton={
        <Button label={iconOnly ? "" : buttonLabel}>
          <AttachFileIcon />
        </Button>
      }
    >
      <Box sx={dropZoneSx}>
        <FileInputWithlabel
          displayLabel={label}
          placeholderText={placeholderText}
          validate={required()}
        />
      </Box>
    </FormModal>
  );
};

export default AttachFileDialog;
